import { render, staticRenderFns } from "./NewWorkout.vue?vue&type=template&id=6318681c&scoped=true&"
import script from "./NewWorkout.vue?vue&type=script&lang=js&"
export * from "./NewWorkout.vue?vue&type=script&lang=js&"
import style0 from "./NewWorkout.vue?vue&type=style&index=0&id=6318681c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318681c",
  null
  
)

export default component.exports